export enum InviteFlow {
  STANDALONE = 'STANDALONE',
  GLOBAL_REGISTRATION = 'GLOBAL_REGISTRATION',
  DISABLED = 'DISABLED',
}
